import React, { useCallback, useState } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import authActions from '../../store/actions/authActions';
import Input from '../UI/Input';
import Preloader from '../UI/Preloader';
import helpers from '../../helpers/helpers';

const AuthSidebarSignIn = ({ toggleSidebar, closeAuthSidebar }) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.auth);

  const { getTranslationText } = helpers;

  const [emailValue, handleEmailValue] = useState('');
  const [passwordValue, handlePasswordValue] = useState('');
  const [captchaValue, handleCaptchaValue] = useState('');
  const [is2fa, handle2fa] = useState(false);
  const [code2fa, handleCode2faValue] = useState('');

  const emailChangeHandler = useCallback((event) => { handleEmailValue(event.target.value); }, []);
  const passwordChangeHandler = useCallback((event) => {
    handlePasswordValue(event.target.value);
  }, []);
  const code2faChangeHandler = useCallback((event) => {
    handleCode2faValue(event.target.value);
  }, []);

  const signIn = () => {
    const dataWithout2fa = {
      email: emailValue,
      password: passwordValue,
      captcha: captchaValue,
    };

    const dataWith2fa = {
      email: emailValue,
      password: passwordValue,
      captcha: captchaValue,
      google: code2fa,
    };

    dispatch(authActions.signIn(is2fa ? dataWith2fa : dataWithout2fa))
      .then((response) => {
        if (response?.data.data.google_2fa) {
          handle2fa(true);
        } else if (response?.data.success) {
          closeAuthSidebar();
        }
      });
  };

  return (
    <div>
      { isLoading && <Preloader /> }
      <div className="auth-sidebar__content__title">{getTranslationText('general.sign_in')}</div>
      <Input
        label={getTranslationText('login.email')}
        name="email"
        type="email"
        value={emailValue}
        onChange={emailChangeHandler}
      />
      <Input
        label={getTranslationText('login.password')}
        name="password"
        type="password"
        value={passwordValue}
        onChange={passwordChangeHandler}
      />
      {
        is2fa
          && (
            <Input
              label={getTranslationText('login.2fa')}
              name="2fa_code"
              type="password"
              value={code2fa}
              onChange={code2faChangeHandler}
            />
          )
      }

      <ReCAPTCHA
        // TODO: For future development (Gleb Bigma)
        sitekey={process.env.CAPTCHA_KEY}
        onChange={(value) => handleCaptchaValue(value)}
      />
      <div className="auth-sidebar__footer">
        <div className="auth-sidebar__footer__item">
          {getTranslationText('login.not_member')}
          <div onClick={() => toggleSidebar(false)}>{getTranslationText('login.registr')}</div>
        </div>
        <div className="auth-sidebar__footer__item">
          <button
            type="button"
            className="button primary auth-submit"
            onClick={signIn}
          >
            {getTranslationText('general.sign_in')}
          </button>
        </div>
      </div>
    </div>
  );
};

AuthSidebarSignIn.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  closeAuthSidebar: PropTypes.func.isRequired,
};

export default AuthSidebarSignIn;
